import ConfigService from 'client/util/initializationHandler/ConfigService';
import DataDog from 'client/util/initializationHandler/DataDog';

const handleInitializationPromise = ConfigService.initialize().then(
  () => DataDog.initialize({ serviceName: 'login-ui' }),
);

// TODO: inject plain html error into index.html
export const onReady = (cb: () => void): Promise<void> => handleInitializationPromise.then(cb);
